import React from 'react'
import styles from './styles.module.css'
import SpecsCollapsible from './SpecsCollapsible'

function ItemSpecifications({ specs, theme }) {
  if (!specs) {
    return null
  }

  const specsByCategory = specs.specsByCategory

  return (
    <div className={styles.wrapper}>
      { Object.keys(specsByCategory).map(category =>
        <SpecsCollapsible
          key={category}
          category={category}
          specs={specsByCategory[category]}
          theme={theme}
        />
      )}
    </div>
  )
}

export default ItemSpecifications
